import moment from 'moment-timezone';

import { Day } from '../..';
import { TimePattern, TimePatternSource, TimeSlot } from '../../mnspro-cloud';
import {
  TimePatternSource as ApiSource,
  DayOfWeek,
  TimePatternRequest,
  TimePatternRequestWithId,
  TimePatternResponse,
  TimeSlotRequest,
  TimeSlotResponse,
} from '../../mnspro-cloud/api/v2';
import { asUTC, generateDateFromTime } from '../momentHelper';

const generateDateTimeFromTimeAsUTC = (time: string) =>
  asUTC(generateDateFromTime(time));

const appendSeconds = (time: string) => `${time}:00`;

const convertApiSourceToTimePatternSource = (
  apiSource: ApiSource,
): TimePatternSource => {
  let convertedValue = TimePatternSource.Unknown;
  switch (apiSource) {
    case ApiSource.external: {
      convertedValue = TimePatternSource.External;
      break;
    }
    case ApiSource.manual: {
      convertedValue = TimePatternSource.Manual;
      break;
    }
    case ApiSource.unknown: {
      convertedValue = TimePatternSource.Unknown;
      break;
    }
  }
  return convertedValue;
};

export const dayOfWeekToDay = (day: DayOfWeek): Day => {
  return day as unknown as Day;
  // const upperCaseDayOfWeek = (day.charAt(0).toUpperCase() +
  //   day.slice(1)) as Day;
  // return Day[upperCaseDayOfWeek];
};

export const timeSlotResponseToTimeSlot = (
  slotResponse: TimeSlotResponse,
): TimeSlot => {
  return {
    name: slotResponse.name as string,
    start: moment(
      generateDateTimeFromTimeAsUTC(slotResponse.start as string),
    ).format('HH:mm'),
    end: moment(
      generateDateTimeFromTimeAsUTC(slotResponse.end as string),
    ).format('HH:mm'),
    period: slotResponse.period,
    isBreak: slotResponse.period < 0,
  };
};

export const timeSlotToTimeSlotRequest = (
  timeSlot: TimeSlot,
): TimeSlotRequest => {
  return {
    name: timeSlot.name,
    start: appendSeconds(timeSlot.start),
    end: appendSeconds(timeSlot.end),
  };
};

export const timePatternResponseToTimePattern = (
  patternResponse: TimePatternResponse,
): TimePattern => {
  const allSlots =
    patternResponse.slots?.map(timeSlotResponseToTimeSlot) ?? [];
  return {
    id: patternResponse.id,
    isActive: patternResponse.isActive ?? false,
    weekdays:
      patternResponse.weekdays?.map(value => dayOfWeekToDay(value)) ?? [],
    slots: allSlots.filter(slot => !slot.isBreak),
    breakSlots: allSlots.filter(slot => slot.isBreak),
    source: patternResponse.source
      ? convertApiSourceToTimePatternSource(patternResponse.source)
      : TimePatternSource.Unknown,
  };
};

export const timePatternToTimePatternRequest = (
  timePattern: TimePattern,
): TimePatternRequest => {
  return {
    slots: timePattern.slots.map(timeSlotToTimeSlotRequest),
    breaks: (timePattern.breakSlots ?? []).map(timeSlotToTimeSlotRequest),
    weekdays: timePattern.weekdays.map(day => day.toLowerCase() as DayOfWeek),
  };
};

export const timePatternToTimePatternRequestWithId = (
  timePattern: TimePattern,
): TimePatternRequestWithId => {
  return {
    id: timePattern.id ?? '',
    ...timePatternToTimePatternRequest(timePattern),
  };
};
